const PROD_HOSTS = new Set(["www.pitagepe.com", "pitagepe.com"]);
const TEST_HOSTS = new Set(["testwww.pitagepe.com"]);

/** 正式 / 测试 sitekey 自行替换 */
const SITE_KEY_PROD = "0x4AAAAAAFF5dmw9VutyHqI9";
const SITE_KEY_TEST = "0x4AAAAAAFF5cNIfWPf2XrOS";
/** Cloudflare 官方 dummy（invisible 自动通过）：本地 127.0.0.1 未绑域名时用 */
const SITE_KEY_LOCAL = "1x00000000000000000000BB";

export function getTurnstileSiteKey() {
  const host = typeof window === "undefined" ? "" : window.location.host;
  if (PROD_HOSTS.has(host)) return SITE_KEY_PROD;
  if (TEST_HOSTS.has(host)) return SITE_KEY_TEST;
  return SITE_KEY_LOCAL;
}

export const TURNSTILE_SITE_KEY = getTurnstileSiteKey();

export function logTurnstileToken(token: string) {
  if (PROD_HOSTS.has(typeof window === "undefined" ? "" : window.location.host)) {
    return;
  }
  if (!token) {
    console.log("[Turnstile] token: 未拿到");
    return;
  }
  console.log(
    `[Turnstile] token: 已拿到 len=${token.length} prefix=${token.slice(0, 20)}…`
  );
}

/** 与后端 siteverify 的 expectedAction 对齐 */
export const TURNSTILE_ACTION = "send-code";

export const TURNSTILE_SCRIPT_SRC =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

/** captchaToken */
export const CAPTCHA_TOKEN_REQ = "gekwdgoujRxijw";

type TurnstileRenderOptions = {
  sitekey: string;
  action?: string;
  theme?: "light" | "dark" | "auto";
  language?: string;
  callback?: (token: string) => void;
  "expired-callback"?: () => void;
  "error-callback"?: () => void;
};

type TurnstileApi = {
  render: (el: HTMLElement, options: TurnstileRenderOptions) => string;
  reset: (widgetId?: string) => void;
  remove: (widgetId?: string) => void;
};

declare global {
  interface Window {
    turnstile?: TurnstileApi;
  }
}

let scriptPromise: Promise<TurnstileApi | undefined> | null = null;

export function loadTurnstileScript() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      'script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]'
    );
    if (existing) {
      if (window.turnstile) {
        resolve(window.turnstile);
        return;
      }
      existing.addEventListener("load", () => resolve(window.turnstile), {
        once: true,
      });
      existing.addEventListener(
        "error",
        () => {
          scriptPromise = null;
          reject(new Error("No se pudo cargar Turnstile"));
        },
        { once: true }
      );
      return;
    }

    const script = document.createElement("script");
    script.src = TURNSTILE_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.turnstile);
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error("No se pudo cargar Turnstile"));
    };
    document.head.appendChild(script);
  });

  return scriptPromise;
}
